function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n        filter: url(#filter);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
  id: "filter",
  x: 0.063,
  y: 0.063,
  width: 72.875,
  height: 72.875,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feImage", {
  preserveAspectRatio: "none",
  x: 0.0625,
  y: 0.0625,
  width: 72.875,
  height: 72.875,
  result: "image",
  xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNzIuODc1IiBoZWlnaHQ9IjcyLjg3NSIgdmlld0JveD0iMCAwIDcyLjg3NSA3Mi44NzUiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IHVybCgjbGluZWFyLWdyYWRpZW50KTsKICAgICAgfQogICAgPC9zdHlsZT4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB4MT0iNzIuODc1IiB5MT0iNjguMTEyIiB4Mj0iMCIgeTI9IjQuNzYzIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzAwM2VjZCIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMDVhZTMiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjcyLjg3NSIgaGVpZ2h0PSI3Mi44NzUiLz4KPC9zdmc+Cg=="
}), /*#__PURE__*/React.createElement("feComposite", {
  result: "composite",
  operator: "in",
  in2: "SourceGraphic"
}), /*#__PURE__*/React.createElement("feBlend", {
  result: "blend",
  in2: "SourceGraphic"
}), /*#__PURE__*/React.createElement("feFlood", {
  result: "flood",
  floodColor: "#253858"
}), /*#__PURE__*/React.createElement("feComposite", {
  result: "composite-2",
  operator: "in",
  in2: "SourceGraphic"
}), /*#__PURE__*/React.createElement("feBlend", {
  result: "blend-2",
  in2: "blend"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Data_Analysis",
  "data-name": "Data Analysis",
  className: "cls-1",
  d: "M63.544,7.1V32.972H72.95V7.1H63.544ZM70.6,30.62H65.9V9.455h4.7V30.62ZM51.785,19a28.249,28.249,0,0,0-2.352-1.888v-0.6H48.548a28.265,28.265,0,0,0-15.576-4.7H31.8V41.2h29.4V40.027a28.216,28.216,0,0,0-.91-7.055h0.91V11.807H51.785V19ZM34.148,38.85V14.184a25.879,25.879,0,0,1,9.558,2.326H40.027V32.972h9.407V20.117A25.715,25.715,0,0,1,51.785,22.3V32.972h6.063a25.878,25.878,0,0,1,.967,5.879H34.148ZM47.082,18.862V30.62h-4.7V18.862h4.7Zm7.055-4.7h4.7V30.62h-4.7V14.159ZM9.213,45.661l9.993-9.994,1.663,1.663-9.993,9.994ZM14.16,36.5a3.527,3.527,0,1,0-3.527,3.528A3.532,3.532,0,0,0,14.16,36.5Zm-4.7,0a1.176,1.176,0,1,1,1.176,1.177A1.176,1.176,0,0,1,9.456,36.5Zm10.582,5.88a3.527,3.527,0,1,0,3.527,3.527A3.532,3.532,0,0,0,20.039,42.378Zm0,4.7a1.176,1.176,0,1,1,1.176-1.176A1.176,1.176,0,0,1,20.039,47.081ZM51.617,60.536a27.983,27.983,0,0,0,4.871-15.807V43.554H29.445V16.511H28.269a28.226,28.226,0,0,0-3.527.251V0.049H0.05V16.511h14.8l2.3,2.3a28.2,28.2,0,1,0,29.583,47.22l3.638,3.638a3.67,3.67,0,0,0,5.19-5.19Zm-35.8-46.377H2.4V2.4H22.39V20.727ZM28.269,70.6a25.857,25.857,0,0,1-9.316-49.982L24.742,26.4V19.121c0.787-.108,1.573-0.2,2.352-0.232V45.905H54.111a25.6,25.6,0,0,1-4.184,12.941l-1.875-1.875a7.1,7.1,0,1,0-5.19,5.19l2.2,2.2A25.727,25.727,0,0,1,28.269,70.6ZM45.906,55.312a4.7,4.7,0,1,1-4.7-4.7A4.708,4.708,0,0,1,45.906,55.312ZM53.894,68a1.319,1.319,0,0,1-1.865,0l-6.86-6.86a7.1,7.1,0,0,0,1.865-1.865l6.86,6.86A1.32,1.32,0,0,1,53.894,68ZM4.753,4.752H20.039V7.1H4.753V4.752Zm0,4.7H20.039v2.352H4.753V9.455Zm35.274,44.68h2.352v2.352H40.027V54.136Zm-10.582,0H31.8v2.352H29.445V54.136Zm-4.7,0h2.352v2.352H24.742V54.136Zm-4.7,0H22.39v2.352H20.039V54.136Z"
});

var SvgWhatWeDo3 = function SvgWhatWeDo3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 73 73",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatWeDo3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatWeDo3.b1c0b88f.svg";
export { ForwardRef as ReactComponent };